import React, { useEffect } from "react";
import Header from "../component/header";
import Footer from "../component/footer";
import Banner from "../component/gethire/banner";
import RemoteTeam from "../component/gethire/remoteteam";
import Client from "../component/gethire/client";
import ExplorePosition from "../component/gethire/exploreposition";
import RemoteJob from "../component/gethire/remotejob";
import WhoApply from "../component/gethire/whoapply";
import HireSteps from "../component/gethire/hiresteps";
import Testimonial from "../component/gethire/testimonial";
import Faq from "../component/gethire/faq";
import SingleClick from "../component/gethire/singleclick";

const GetHire = () => {
  useEffect(() => {
    document.body.className = "";
  }, []);
  return (
    <>
      <Header />
      <Banner />
      <RemoteTeam />
      <Client />
      <ExplorePosition />
      <RemoteJob />
      <WhoApply />
      <HireSteps />
      <Testimonial />
      <Faq />
      <SingleClick />
      <Footer />
    </>
  );
};

export default GetHire;
